import VisualizeInstructors from '../components/course/visualize-instructors';
<template><VisualizeInstructors @model={{@model}} /></template>
